module.exports = __webpack_public_path__ + "img/UI_common_framelabelFX_01_d729ecb07.png";